// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cr-page-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 85px);
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 2rem;
  margin-bottom: 3.5rem;
}
.page-header h1 {
  margin: 0;
}
.page-header .back-arrow {
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: #04abbd;
  text-decoration: none;
  font-size: 18px;
  border-radius: 4px;
  transition: background 0.2s, color 0.2s;
}
.page-header .back-arrow:hover {
  background: rgba(4, 171, 189, 0.1);
  color: #03929e;
  text-decoration: none;
}
.page-header .back-arrow i {
  font-size: 18px;
}

.cr-discussion-container {
  display: flex;
  flex: 1;
  overflow: hidden;
  background: #f5f5f5;
  border: 2px solid #303942;
  border-radius: 4px 4px 4px 4px;
}

.cr-list-panel {
  width: 350px;
  min-width: 300px;
  background: #fff;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
}

.cr-list-header {
  padding: 20px;
}
.cr-list-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.cr-list-content {
  flex: 1;
  overflow-y: auto;
}

.cr-loading,
.cr-no-data {
  padding: 20px;
  text-align: center;
  color: #999;
}

.cr-item {
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
}
.cr-item:hover {
  background: #f8f9fa;
}
.cr-item.selected {
  background: #e3f2fd;
  border-left: 3px solid #2196f3;
}

.cr-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.cr-eurocode {
  font-weight: 600;
  font-size: 15px;
  color: #333;
}

.cr-status-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
}
.cr-status-badge.status-new {
  background: #e3f2fd;
  color: #1976d2;
}
.cr-status-badge.status-discussion {
  background: #fff3e0;
  color: #f57c00;
}
.cr-status-badge.status-approved {
  background: #e8f5e9;
  color: #388e3c;
}
.cr-status-badge.status-rejected {
  background: #ffebee;
  color: #d32f2f;
}

.cr-item-subtitle {
  font-size: 13px;
  color: #666;
  margin-bottom: 5px;
  line-height: 1.4;
}

.cr-item-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
}

.cr-chat-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.cr-chat-header {
  padding: 15px 20px;
  background: #f0f0f0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.cr-chat-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.cr-header-btn {
  flex-shrink: 0;
}

.cr-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
}

.cr-modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 420px;
  max-width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}
.cr-modal.cr-modal-lg {
  width: 560px;
  height: 90vh;
}

.cr-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
}
.cr-modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.cr-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 16px;
  padding: 4px;
  border-radius: 4px;
  line-height: 1;
}
.cr-modal-close:hover {
  color: #333;
  background: #f0f0f0;
}

.cr-modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.cr-modal-footer {
  padding: 12px 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.cr-modal-section-title {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.cr-modal-divider {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 16px 0;
}

.cr-modal-loading {
  color: #999;
  font-size: 13px;
  padding: 8px 0;
}

.cr-modal-empty {
  color: #aaa;
  font-size: 13px;
  font-style: italic;
}

.cr-status-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cr-status-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.cr-status-option:hover {
  background: #f8f9fa;
  border-color: #b0bec5;
}
.cr-status-option.selected {
  border-color: #2196f3;
  background: #e3f2fd;
}

.cr-status-check {
  color: #2196f3;
  font-size: 14px;
}

.cr-participant-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 220px;
  overflow-y: auto;
}

.cr-participant-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-radius: 6px;
  background: #f8f9fa;
}
.cr-participant-row:hover {
  background: #f0f0f0;
}

.cr-participant-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cr-participant-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.cr-participant-company {
  font-size: 12px;
  color: #999;
}

.cr-participant-remove {
  width: 30px !important;
  height: 30px !important;
  padding: 0 !important;
  flex-shrink: 0;
}

.cr-add-row {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.cr-combo-dropdown {
  width: 100%;
  max-width: 330px;
}

.cr-combo {
  flex: 1;
  min-width: 0;
  max-width: 400px;
  width: 300px;
}

::ng-deep .cr-combo.p-dropdown {
  width: 100%;
}

.cr-select {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  background: #fff;
  color: #333;
}
.cr-select:focus {
  border-color: #2196f3;
}

.cr-add-btn {
  flex-shrink: 0;
}

.cr-chat-header-info {
  display: flex;
  flex-direction: column;
}

.cr-chat-eurocode {
  font-weight: 600;
  font-size: 16px;
}

.cr-chat-description {
  font-size: 13px;
  color: #b0bec5;
  margin-top: 2px;
}

.cr-chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #e5ddd5;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cr-messages-loading,
.cr-no-messages {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #999;
}

.cr-message {
  max-width: 70%;
  padding: 10px 15px;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.cr-message.own-message {
  align-self: flex-end;
  background: #dcf8c6;
}
.cr-message.deleted-message {
  background: #f5f5f5;
  color: #999;
  font-style: italic;
}

.cr-message-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}

.cr-message-author {
  font-weight: 600;
  font-size: 13px;
  color: #333;
}

.cr-message-date {
  font-size: 11px;
  color: #999;
}

.cr-message-delete {
  margin-left: auto;
  background: none !important;
  border: none !important;
  color: #999 !important;
  padding: 2px !important;
  width: auto !important;
  height: auto !important;
}
.cr-message-delete:hover {
  color: #d32f2f !important;
}

.cr-message-content {
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  word-break: break-word;
}

.cr-message-deleted {
  font-size: 13px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 5px;
}

.cr-message-attachments {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cr-attachment {
  cursor: pointer;
}

.attachment-image-preview {
  max-width: 200px;
  border-radius: 4px;
  overflow: hidden;
}
.attachment-image-preview img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.2s;
}
.attachment-image-preview img:hover {
  transform: scale(1.02);
}

.attachment-pdf,
.attachment-file {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  transition: background 0.2s;
}
.attachment-pdf:hover,
.attachment-file:hover {
  background: #e0e0e0;
}
.attachment-pdf i,
.attachment-file i {
  font-size: 18px;
}
.attachment-pdf .attachment-size,
.attachment-file .attachment-size {
  color: #999;
  font-size: 11px;
}

.attachment-pdf i {
  color: #d32f2f;
}

.attachment-file i {
  color: #666;
}

.cr-chat-input {
  padding: 15px 20px;
  background: #f0f0f0;
  border-top: 1px solid #e0e0e0;
}
.cr-chat-input.readonly {
  background: #f5f5f5;
}

.cr-readonly-notice {
  text-align: center;
  color: #999;
  font-size: 13px;
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 10px;
}

.cr-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cr-message-input {
  flex: 1;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}
.cr-message-input:focus {
  border-color: #2196f3;
}
.cr-message-input:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.cr-send-btn {
  background: #2196f3 !important;
  border: none !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
}
.cr-send-btn:disabled {
  background: #b0bec5 !important;
}

.cr-attach-btn {
  background: #666 !important;
  border: none !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
}

.cr-file-upload {
  width: 40px !important;
  height: 40px !important;
}
.cr-file-upload :host ::ng-deep .p-button {
  background: #666 !important;
  border: none !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  padding: 0 !important;
}

.cr-uploaded-files {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.cr-file-chip {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  background: #fff;
  border-radius: 15px;
  font-size: 12px;
  border: 1px solid #ddd;
}
.cr-file-chip i {
  cursor: pointer;
  color: #999;
}
.cr-file-chip i:hover {
  color: #d32f2f;
}

.cr-file-error {
  color: #d32f2f;
  font-size: 12px;
  margin-top: 5px;
}

.cr-no-selection {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #999;
}
.cr-no-selection i {
  font-size: 48px;
  margin-bottom: 15px;
}
.cr-no-selection p {
  font-size: 16px;
}

.cr-mobile-back {
  display: none;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 6px 10px 6px 4px;
  margin-right: 4px;
  font-size: 16px;
}
.cr-mobile-back:hover {
  color: rgba(255, 255, 255, 0.75);
}

@media (max-width: 768px) {
  .cr-list-panel {
    width: 100%;
    min-width: 0;
    border-right: none;
  }
  .cr-chat-panel {
    width: 100%;
  }
  .cr-discussion-container {
    position: relative;
  }
  .mobile-hidden {
    display: none !important;
  }
  .cr-mobile-back {
    display: flex;
    align-items: center;
  }
}
:host ::ng-deep .p-fileUpload {
  display: inline-block;
}

.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  cursor: pointer;
}
.image-preview-modal .close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  z-index: 10001;
}
.image-preview-modal .close-btn:hover {
  background: rgba(255, 255, 255, 0.25);
}
.image-preview-modal .image-container {
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
}
.image-preview-modal .image-container img {
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/app/argic/view/change-request-discussion/change-request-discussion.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,0BAAA;EAEA,sBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;AAEI;EACI,SAAA;AAAR;AAGI;EACI,kBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,uCAAA;AADR;AAGQ;EACI,kCAAA;EACA,cAAA;EACA,qBAAA;AADZ;AAIQ;EACI,eAAA;AAFZ;;AAOA;EACI,aAAA;EACA,OAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AAJJ;;AAOA;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;AAQI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;AANR;;AAUA;EACI,OAAA;EACA,gBAAA;AAPJ;;AAUA;;EAEI,aAAA;EACA,kBAAA;EACA,WAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,2BAAA;AAPJ;AASI;EACI,mBAAA;AAPR;AAUI;EACI,mBAAA;EACA,8BAAA;AARR;;AAYA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AATJ;;AAYA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;AATJ;;AAYA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AATJ;AAWI;EACI,mBAAA;EACA,cAAA;AATR;AAYI;EACI,mBAAA;EACA,cAAA;AAVR;AAaI;EACI,mBAAA;EACA,cAAA;AAXR;AAcI;EACI,mBAAA;EACA,cAAA;AAZR;;AAgBA;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;AAbJ;;AAgBA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAbJ;;AAgBA;EACI,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAbJ;;AAgBA;EACI,cAAA;AAbJ;;AAkBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAfJ;;AAkBA;EACI,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAfJ;AAiBI;EACI,YAAA;EACA,YAAA;AAfR;;AAmBA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AAhBJ;AAkBI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;AAhBR;;AAoBA;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAjBJ;AAmBI;EACI,WAAA;EACA,mBAAA;AAjBR;;AAqBA;EACI,aAAA;EACA,gBAAA;EACA,OAAA;AAlBJ;;AAqBA;EACI,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;AAlBJ;;AAqBA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AAlBJ;;AAqBA;EACI,YAAA;EACA,6BAAA;EACA,cAAA;AAlBJ;;AAqBA;EACI,WAAA;EACA,eAAA;EACA,cAAA;AAlBJ;;AAqBA;EACI,WAAA;EACA,eAAA;EACA,kBAAA;AAlBJ;;AAuBA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AApBJ;;AAuBA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gDAAA;AApBJ;AAsBI;EACI,mBAAA;EACA,qBAAA;AApBR;AAuBI;EACI,qBAAA;EACA,mBAAA;AArBR;;AAyBA;EACI,cAAA;EACA,eAAA;AAtBJ;;AA2BA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAxBJ;;AA2BA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAxBJ;AA0BI;EACI,mBAAA;AAxBR;;AA4BA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAzBJ;;AA4BA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAzBJ;;AA4BA;EACI,eAAA;EACA,WAAA;AAzBJ;;AA4BA;EACI,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;AAzBJ;;AA4BA;EACI,aAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;AAzBJ;;AA4BA;EACI,WAAA;EACA,gBAAA;AAzBJ;;AA4BA;EACI,OAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAzBJ;;AAiCA;EACI,WAAA;AA9BJ;;AAiCA;EACI,OAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AA9BJ;AAgCI;EACI,qBAAA;AA9BR;;AAkCA;EACI,cAAA;AA/BJ;;AAoCA;EACI,aAAA;EACA,sBAAA;AAjCJ;;AAoCA;EACI,gBAAA;EACA,eAAA;AAjCJ;;AAoCA;EACI,eAAA;EACA,cAAA;EACA,eAAA;AAjCJ;;AAoCA;EACI,OAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjCJ;;AAoCA;;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAjCJ;;AAoCA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AAjCJ;AAmCI;EACI,oBAAA;EACA,mBAAA;AAjCR;AAoCI;EACI,mBAAA;EACA,WAAA;EACA,kBAAA;AAlCR;;AAsCA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAnCJ;;AAsCA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;AAnCJ;;AAsCA;EACI,eAAA;EACA,WAAA;AAnCJ;;AAsCA;EACI,iBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;AAnCJ;AAqCI;EACI,yBAAA;AAnCR;;AAuCA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AApCJ;;AAuCA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AApCJ;;AAuCA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AApCJ;;AAuCA;EACI,eAAA;AApCJ;;AAuCA;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;AApCJ;AAsCI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;AApCR;AAsCQ;EACI,sBAAA;AApCZ;;AAyCA;;EAEI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;AAtCJ;AAwCI;;EACI,mBAAA;AArCR;AAwCI;;EACI,eAAA;AArCR;AAwCI;;EACI,WAAA;EACA,eAAA;AArCR;;AAyCA;EACI,cAAA;AAtCJ;;AAyCA;EACI,WAAA;AAtCJ;;AAyCA;EACI,kBAAA;EACA,mBAAA;EACA,6BAAA;AAtCJ;AAwCI;EACI,mBAAA;AAtCR;;AA0CA;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAvCJ;;AA0CA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAvCJ;;AA0CA;EACI,OAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;AAvCJ;AAyCI;EACI,qBAAA;AAvCR;AA0CI;EACI,mBAAA;EACA,mBAAA;AAxCR;;AA4CA;EACI,8BAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;AAzCJ;AA2CI;EACI,8BAAA;AAzCR;;AA6CA;EACI,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;AA1CJ;;AA6CA;EACI,sBAAA;EACA,uBAAA;AA1CJ;AA4CI;EACI,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,qBAAA;AA1CR;;AA8CA;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AA3CJ;;AA8CA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AA3CJ;AA6CI;EACI,eAAA;EACA,WAAA;AA3CR;AA6CQ;EACI,cAAA;AA3CZ;;AAgDA;EACI,cAAA;EACA,eAAA;EACA,eAAA;AA7CJ;;AAgDA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AA7CJ;AA+CI;EACI,eAAA;EACA,mBAAA;AA7CR;AAgDI;EACI,eAAA;AA9CR;;AAkDA;EACI,aAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AA/CJ;AAiDI;EACI,gCAAA;AA/CR;;AAmDA;EACI;IACI,WAAA;IACA,YAAA;IACA,kBAAA;EAhDN;EAmDE;IACI,WAAA;EAjDN;EAoDE;IACI,kBAAA;EAlDN;EAqDE;IACI,wBAAA;EAnDN;EAsDE;IACI,aAAA;IACA,mBAAA;EApDN;AACF;AAwDI;EACI,qBAAA;AAtDR;;AA0DA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAvDJ;AAyDI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,cAAA;AAvDR;AAyDQ;EACI,qCAAA;AAvDZ;AA2DI;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAzDR;AA2DQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAzDZ","sourcesContent":[".cr-page-wrapper {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 85px);\n    \n    box-sizing: border-box;\n}\n\n.page-header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    padding-top: 2rem;\n    margin-bottom: 3.5rem;\n\n    h1 {\n        margin: 0;\n    }\n\n    .back-arrow {\n        position: absolute;\n        left: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 40px;\n        height: 40px;\n        color: #04abbd;\n        text-decoration: none;\n        font-size: 18px;\n        border-radius: 4px;\n        transition: background 0.2s, color 0.2s;\n\n        &:hover {\n            background: rgba(4, 171, 189, 0.1);\n            color: #03929e;\n            text-decoration: none;\n        }\n\n        i {\n            font-size: 18px;\n        }\n    }\n}\n\n.cr-discussion-container {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n    background: #f5f5f5;\n    border: 2px solid #303942;\n    border-radius: 4px 4px 4px 4px;\n}\n\n.cr-list-panel {\n    width: 350px;\n    min-width: 300px;\n    background: #fff;\n    border-right: 1px solid #e0e0e0;\n    display: flex;\n    flex-direction: column;\n}\n\n.cr-list-header {\n    padding: 20px;\n    // background: #303942;\n    // color: #fff;\n    \n    h3 {\n        margin: 0;\n        font-size: 18px;\n        font-weight: 600;\n    }\n}\n\n.cr-list-content {\n    flex: 1;\n    overflow-y: auto;\n}\n\n.cr-loading,\n.cr-no-data {\n    padding: 20px;\n    text-align: center;\n    color: #999;\n}\n\n.cr-item {\n    padding: 15px 20px;\n    border-bottom: 1px solid #f0f0f0;\n    cursor: pointer;\n    transition: background 0.2s;\n    \n    &:hover {\n        background: #f8f9fa;\n    }\n    \n    &.selected {\n        background: #e3f2fd;\n        border-left: 3px solid #2196f3;\n    }\n}\n\n.cr-item-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 5px;\n}\n\n.cr-eurocode {\n    font-weight: 600;\n    font-size: 15px;\n    color: #333;\n}\n\n.cr-status-badge {\n    font-size: 11px;\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-weight: 500;\n    \n    &.status-new {\n        background: #e3f2fd;\n        color: #1976d2;\n    }\n    \n    &.status-discussion {\n        background: #fff3e0;\n        color: #f57c00;\n    }\n    \n    &.status-approved {\n        background: #e8f5e9;\n        color: #388e3c;\n    }\n    \n    &.status-rejected {\n        background: #ffebee;\n        color: #d32f2f;\n    }\n}\n\n.cr-item-subtitle {\n    font-size: 13px;\n    color: #666;\n    margin-bottom: 5px;\n    line-height: 1.4;\n}\n\n.cr-item-meta {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    color: #999;\n}\n\n.cr-chat-panel {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n}\n\n.cr-chat-header {\n    padding: 15px 20px;\n    background: #f0f0f0;\n    border-bottom:1px solid #e0e0e0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n\n.cr-chat-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.cr-header-btn {\n    flex-shrink: 0;\n}\n\n// ── Shared modal styles ───────────────────────────────────────────────────────\n\n.cr-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 5000;\n}\n\n.cr-modal {\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n    width: 420px;\n    max-width: 95vw;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n\n    &.cr-modal-lg {\n        width: 560px;\n        height:90vh;\n    }\n}\n\n.cr-modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid #e0e0e0;\n\n    h3 {\n        margin: 0;\n        font-size: 16px;\n        font-weight: 600;\n    }\n}\n\n.cr-modal-close {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #999;\n    font-size: 16px;\n    padding: 4px;\n    border-radius: 4px;\n    line-height: 1;\n\n    &:hover {\n        color: #333;\n        background: #f0f0f0;\n    }\n}\n\n.cr-modal-body {\n    padding: 20px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.cr-modal-footer {\n    padding: 12px 20px;\n    border-top: 1px solid #e0e0e0;\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.cr-modal-section-title {\n    font-size: 13px;\n    font-weight: 600;\n    color: #555;\n    margin: 0 0 10px 0;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n}\n\n.cr-modal-divider {\n    border: none;\n    border-top: 1px solid #f0f0f0;\n    margin: 16px 0;\n}\n\n.cr-modal-loading {\n    color: #999;\n    font-size: 13px;\n    padding: 8px 0;\n}\n\n.cr-modal-empty {\n    color: #aaa;\n    font-size: 13px;\n    font-style: italic;\n}\n\n// ── Status modal ──────────────────────────────────────────────────────────────\n\n.cr-status-options {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.cr-status-option {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px;\n    border: 2px solid #e0e0e0;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: border-color 0.15s, background 0.15s;\n\n    &:hover {\n        background: #f8f9fa;\n        border-color: #b0bec5;\n    }\n\n    &.selected {\n        border-color: #2196f3;\n        background: #e3f2fd;\n    }\n}\n\n.cr-status-check {\n    color: #2196f3;\n    font-size: 14px;\n}\n\n// ── Participants modal ────────────────────────────────────────────────────────\n\n.cr-participant-list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-height: 220px;\n    overflow-y: auto;\n}\n\n.cr-participant-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 10px;\n    border-radius: 6px;\n    background: #f8f9fa;\n\n    &:hover {\n        background: #f0f0f0;\n    }\n}\n\n.cr-participant-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.cr-participant-name {\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n}\n\n.cr-participant-company {\n    font-size: 12px;\n    color: #999;\n}\n\n.cr-participant-remove {\n    width: 30px !important;\n    height: 30px !important;\n    padding: 0 !important;\n    flex-shrink: 0;\n}\n\n.cr-add-row {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    width: 100%;\n}\n\n.cr-combo-dropdown {\n    width: 100%;\n    max-width: 330px;\n}\n\n.cr-combo {\n    flex: 1;\n    min-width: 0;\n    max-width: 400px;\n    width: 300px;\n\n    // :host ::ng-deep &.p-dropdown,\n    // &.p-dropdown {\n    //     width: 100%;\n    // }\n}\n\n::ng-deep .cr-combo.p-dropdown {\n    width: 100%;\n}\n\n.cr-select {\n    flex: 1;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n    outline: none;\n    background: #fff;\n    color: #333;\n\n    &:focus {\n        border-color: #2196f3;\n    }\n}\n\n.cr-add-btn {\n    flex-shrink: 0;\n}\n\n\n\n.cr-chat-header-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.cr-chat-eurocode {\n    font-weight: 600;\n    font-size: 16px;\n}\n\n.cr-chat-description {\n    font-size: 13px;\n    color: #b0bec5;\n    margin-top: 2px;\n}\n\n.cr-chat-messages {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px;\n    background: #e5ddd5;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.cr-messages-loading,\n.cr-no-messages {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    color: #999;\n}\n\n.cr-message {\n    max-width: 70%;\n    padding: 10px 15px;\n    border-radius: 7px;\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n    \n    &.own-message {\n        align-self: flex-end;\n        background: #dcf8c6;\n    }\n    \n    &.deleted-message {\n        background: #f5f5f5;\n        color: #999;\n        font-style: italic;\n    }\n}\n\n.cr-message-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 5px;\n}\n\n.cr-message-author {\n    font-weight: 600;\n    font-size: 13px;\n    color: #333;\n}\n\n.cr-message-date {\n    font-size: 11px;\n    color: #999;\n}\n\n.cr-message-delete {\n    margin-left: auto;\n    background: none !important;\n    border: none !important;\n    color: #999 !important;\n    padding: 2px !important;\n    width: auto !important;\n    height: auto !important;\n    \n    &:hover {\n        color: #d32f2f !important;\n    }\n}\n\n.cr-message-content {\n    font-size: 14px;\n    line-height: 1.4;\n    color: #333;\n    word-break: break-word;\n}\n\n.cr-message-deleted {\n    font-size: 13px;\n    color: #999;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.cr-message-attachments {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.cr-attachment {\n    cursor: pointer;\n}\n\n.attachment-image-preview {\n    max-width: 200px;\n    border-radius: 4px;\n    overflow: hidden;\n    \n    img {\n        width: 100%;\n        height: auto;\n        display: block;\n        transition: transform 0.2s;\n        \n        &:hover {\n            transform: scale(1.02);\n        }\n    }\n}\n\n.attachment-pdf,\n.attachment-file {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    background: #f5f5f5;\n    border-radius: 4px;\n    font-size: 13px;\n    color: #333;\n    transition: background 0.2s;\n    \n    &:hover {\n        background: #e0e0e0;\n    }\n    \n    i {\n        font-size: 18px;\n    }\n    \n    .attachment-size {\n        color: #999;\n        font-size: 11px;\n    }\n}\n\n.attachment-pdf i {\n    color: #d32f2f;\n}\n\n.attachment-file i {\n    color: #666;\n}\n\n.cr-chat-input {\n    padding: 15px 20px;\n    background: #f0f0f0;\n    border-top: 1px solid #e0e0e0;\n    \n    &.readonly {\n        background: #f5f5f5;\n    }\n}\n\n.cr-readonly-notice {\n    text-align: center;\n    color: #999;\n    font-size: 13px;\n    padding: 10px;\n    background: #fff;\n    border-radius: 4px;\n    margin-bottom: 10px;\n}\n\n.cr-input-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.cr-message-input {\n    flex: 1;\n    padding: 12px 15px;\n    border: 1px solid #ddd;\n    border-radius: 20px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s;\n    \n    &:focus {\n        border-color: #2196f3;\n    }\n    \n    &:disabled {\n        background: #f5f5f5;\n        cursor: not-allowed;\n    }\n}\n\n.cr-send-btn {\n    background: #2196f3 !important;\n    border: none !important;\n    width: 40px !important;\n    height: 40px !important;\n    border-radius: 50% !important;\n    \n    &:disabled {\n        background: #b0bec5 !important;\n    }\n}\n\n.cr-attach-btn {\n    background: #666 !important;\n    border: none !important;\n    width: 40px !important;\n    height: 40px !important;\n    border-radius: 50% !important;\n}\n\n.cr-file-upload {\n    width: 40px !important;\n    height: 40px !important;\n    \n    :host ::ng-deep .p-button {\n        background: #666 !important;\n        border: none !important;\n        width: 40px !important;\n        height: 40px !important;\n        border-radius: 50% !important;\n        padding: 0 !important;\n    }\n}\n\n.cr-uploaded-files {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 10px;\n}\n\n.cr-file-chip {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 5px 10px;\n    background: #fff;\n    border-radius: 15px;\n    font-size: 12px;\n    border: 1px solid #ddd;\n    \n    i {\n        cursor: pointer;\n        color: #999;\n        \n        &:hover {\n            color: #d32f2f;\n        }\n    }\n}\n\n.cr-file-error {\n    color: #d32f2f;\n    font-size: 12px;\n    margin-top: 5px;\n}\n\n.cr-no-selection {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: #999;\n    \n    i {\n        font-size: 48px;\n        margin-bottom: 15px;\n    }\n    \n    p {\n        font-size: 16px;\n    }\n}\n\n.cr-mobile-back {\n    display: none;\n    background: none;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    padding: 6px 10px 6px 4px;\n    margin-right: 4px;\n    font-size: 16px;\n\n    &:hover {\n        color: rgba(255, 255, 255, 0.75);\n    }\n}\n\n@media (max-width: 768px) {\n    .cr-list-panel {\n        width: 100%;\n        min-width: 0;\n        border-right: none;\n    }\n\n    .cr-chat-panel {\n        width: 100%;\n    }\n\n    .cr-discussion-container {\n        position: relative;\n    }\n\n    .mobile-hidden {\n        display: none !important;\n    }\n\n    .cr-mobile-back {\n        display: flex;\n        align-items: center;\n    }\n}\n\n:host ::ng-deep {\n    .p-fileUpload {\n        display: inline-block;\n    }\n}\n\n.image-preview-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.9);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n    cursor: pointer;\n\n    .close-btn {\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        background: rgba(255, 255, 255, 0.1);\n        border: none;\n        color: #fff;\n        width: 44px;\n        height: 44px;\n        border-radius: 50%;\n        cursor: pointer;\n        font-size: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: background 0.2s;\n        z-index: 10001;\n\n        &:hover {\n            background: rgba(255, 255, 255, 0.25);\n        }\n    }\n\n    .image-container {\n        max-width: 90vw;\n        max-height: 90vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: default;\n\n        img {\n            max-width: 90vw;\n            max-height: 90vh;\n            width: auto;\n            height: auto;\n            object-fit: contain;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
